import lazyImport from '../../Utils/Loading/loadingHelpers'

// Utilities //
export const RefreshIcon = lazyImport(
  () => import(/* webpackChunkName: "mui-icon-refresh" */ '@mui/icons-material/Refresh')
)

// ARROWS //
export const ExpandMoreIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-expand-more" */ '@mui/icons-material/ExpandMore'
    )
)

export const IosShareIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-ios-share" */ '@mui/icons-material/IosShare')
)

// PROFILE //
export const AccountCircleOutlined = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-account-circle-outlined" */ '@mui/icons-material/AccountCircleOutlined'
    )
)

// SOCIAL //
export const GoogleIcon = lazyImport(
  () => import(/* webpackChunkName: "mui-icon-google" */ '@mui/icons-material/Google')
)

// CHART //
export const LineChartIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-show-chart" */ '@mui/icons-material/ShowChart')
)
